/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./runApplications.component";
var styles_RunApplicationsComponent = [];
var RenderType_RunApplicationsComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_RunApplicationsComponent, data: {} });
export { RenderType_RunApplicationsComponent as RenderType_RunApplicationsComponent };
export function View_RunApplicationsComponent_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵted(-1, null, ["placeholder for run applications"]))], null, null); }
export function View_RunApplicationsComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "ng-component", [], null, null, null, View_RunApplicationsComponent_0, RenderType_RunApplicationsComponent)), i0.ɵdid(1, 49152, null, 0, i1.RunApplicationsComponent, [], null, null)], null, null); }
var RunApplicationsComponentNgFactory = i0.ɵccf("ng-component", i1.RunApplicationsComponent, View_RunApplicationsComponent_Host_0, {}, {}, []);
export { RunApplicationsComponentNgFactory as RunApplicationsComponentNgFactory };
